/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolTwoWheelerIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-two-wheeler"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.85 19.25Q2.1 19.25 0.88 18.02Q-0.35 16.8 -0.35 15.05Q-0.35 13.63 0.53 12.5Q1.4 11.38 2.8 11L2.8 11L2.25 10.55L0.47 10.55Q0.13 10.55 -0.11 10.31Q-0.35 10.07 -0.35 9.72Q-0.35 9.38 -0.11 9.14Q0.13 8.9 0.47 8.9L4.45 8.9L6.9 10.35L10.5 9.03Q10.72 8.95 10.95 8.9Q11.18 8.85 11.43 8.85L13.93 8.85L12.53 7Q12.53 7 12.53 7Q12.53 7 12.53 7L10.97 7Q10.5 7 10.18 6.67Q9.85 6.35 9.85 5.88Q9.85 5.4 10.18 5.08Q10.5 4.75 10.97 4.75L12.32 4.75Q12.95 4.75 13.5 5.01Q14.05 5.28 14.43 5.78L15.78 7.55L18.3 6.22Q18.65 6.05 18.96 6.24Q19.27 6.42 19.27 6.8L19.27 8.38Q19.27 8.65 19.09 8.85Q18.9 9.05 18.63 9.05L16.98 9.05L18.6 11.18Q18.95 11 19.34 10.93Q19.73 10.85 20.13 10.85Q21.88 10.85 23.1 12.07Q24.32 13.3 24.32 15.05Q24.32 16.8 23.1 18.02Q21.88 19.25 20.13 19.25Q18.38 19.25 17.15 18.02Q15.93 16.8 15.93 15.05Q15.93 14.35 16.18 13.71Q16.43 13.07 16.85 12.53L16.48 12.1L13.43 16.63Q13.22 16.9 12.95 17.05Q12.68 17.2 12.32 17.2L10.4 17.2Q10.15 17.2 9.94 17.11Q9.72 17.02 9.53 16.88L8.05 15.57L8.05 15.57Q7.72 17.15 6.58 18.2Q5.42 19.25 3.85 19.25ZM3.85 17Q4.65 17 5.22 16.43Q5.8 15.85 5.8 15.05Q5.8 14.25 5.22 13.68Q4.65 13.1 3.85 13.1Q3.05 13.1 2.48 13.68Q1.9 14.25 1.9 15.05Q1.9 15.85 2.48 16.43Q3.05 17 3.85 17ZM20.13 17Q20.93 17 21.5 16.43Q22.07 15.85 22.07 15.05Q22.07 14.25 21.5 13.68Q20.93 13.1 20.13 13.1Q19.32 13.1 18.75 13.68Q18.18 14.25 18.18 15.05Q18.18 15.85 18.75 16.43Q19.32 17 20.13 17Z" fill={color} />
    </svg>
  );
}
